'use strict';

import components from './src/components';
import factories from './src/factories';
import filters from './src/filters';
import features from './src/features';

export const core = {
  components: components,
  factories: factories,
  features: features,
  filters: filters,
};




// WEBPACK FOOTER //
// ./~/site_core/index.js